import { cn } from "@/lib/utils";

export type SelectableDashboardView = "IN_SEASON" | "UPCOMING" | "FINISHED";

const VIEW_LABEL: Record<SelectableDashboardView, string> = {
  IN_SEASON: "In season",
  UPCOMING: "Upcoming",
  FINISHED: "Finished",
};

const VIEWS: SelectableDashboardView[] = ["IN_SEASON", "UPCOMING", "FINISHED"];

interface DashboardViewSwitchProps {
  value: SelectableDashboardView;
  counts?: Record<SelectableDashboardView, number>;
  onChange: (view: SelectableDashboardView) => void;
}

export function DashboardViewSwitch({
  value,
  counts,
  onChange,
}: DashboardViewSwitchProps) {
  return (
    <div className="inline-flex gap-1 rounded-xl bg-muted p-1">
      {VIEWS.map((view) => {
        const selected = view === value;
        const count = counts?.[view];
        return (
          <button
            key={view}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(view)}
            className={cn(
              "mulish relative flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors duration-150 tap-target",
              selected
                ? "bg-surface text-ink shadow-sm"
                : "text-text-muted hover:text-ink",
            )}
          >
            {VIEW_LABEL[view]}
            {count !== undefined && (
              <>
                {" "}
                <span
                  className={cn(
                    "rounded-full px-1.5 py-0.5 text-xs font-medium tabular-nums transition-colors duration-150",
                    selected ? "bg-good-soft text-good" : "bg-surface/60 text-text-muted",
                  )}
                >
                  {count}
                </span>
              </>
            )}
          </button>
        );
      })}
    </div>
  );
}
